export { SidebarModule } from './sidebar.module';

export { SidebarComponent } from './sidebar.component';

export { SidebarService, SidebarOptions } from './sidebar.service';

export * from './sidebar';
